/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import {Account, BaseSearchFilters, EntityStatus} from '@ion/core/src/types/entities';
import {InventoryDevicesSort, InventorySearch} from '@ion/core/src/types/services';
import {createModularSearchFilters} from '@ion/features/src/search/utils';

export enum MANUFACTURING_REGIONS {
  US = 'US',
  EU = 'UK',
  INVENTORY = 'Inventory'
}
export const DEFAULT_REGION = MANUFACTURING_REGIONS.INVENTORY;

interface InventorySearchParams {
  accountId?: Account;
  region?: MANUFACTURING_REGIONS;
  sort?: InventoryDevicesSort[];
  searchParams?: BaseSearchFilters;
}

/**
 * Shared search request generation for retrieving Inventory Devices.
 */
export const buildInventorySearch = ({
  accountId,
  region,
  sort,
  searchParams = {}
}: InventorySearchParams): InventorySearch => {
  return {
    search : {
      sort,
      searchTerms : {
        accountId  : accountId,
        status     : EntityStatus.Enabled,
        currRegion : region,
        ...createModularSearchFilters(searchParams)
      }
    }
  };
};
